import styled from '@emotion/styled';
import {Link} from 'react-router-dom';
import {colors} from 'patient-ping-remedy/packages/theme';

export const NotificationLink = styled(Link)<{ disabled?: boolean }>`
  color: ${colors.blue4};
  text-decoration: none;
  pointer-events: ${({disabled}) => disabled ? 'none': 'auto'};

  & > span {
    color: ${colors.blue4};
  }
`;
